import { create } from "zustand";
import { IEssaySchedule } from "../model/essaySchedule";

type EssayScheduleStore = {
    essaySchedule: IEssaySchedule | null;
    setEssaySchedule: (essaySchedule: IEssaySchedule | null) => void;
};

export const useEssayScheduleStore = create<EssayScheduleStore>((set) => ({
    essaySchedule: null,
    setEssaySchedule: (essaySchedule) => set({ essaySchedule }),
}));
